import React, { Component } from 'react'
import TextField from "@material-ui/core/TextField"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import Switch from "@material-ui/core/Switch"
import './FormReingreso.css'
import axios from 'axios'
import Swal from 'sweetalert2'
import FormControl from '@material-ui/core/FormControl'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import RadioGroup from '@material-ui/core/RadioGroup'
import Radio from '@material-ui/core/Radio'
import FormLabel from '@material-ui/core/FormLabel'
import 'date-fns'
import DateFnsUtils from '@date-io/date-fns'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import locale from "date-fns/locale/es"
import $ from "jquery"
import { DatePicker } from "@material-ui/pickers"
import "jquery-mask-plugin/dist/jquery.mask.min"
import { MDBRow, MDBCol, MDBContainer } from "mdbreact"
import Button from '@material-ui/core/Button'
import SendIcon from '@material-ui/icons/Send'
import Spinner from 'react-bootstrap/Spinner'

let habilitar = true
let idSede = ""

class FormReingreso extends Component {
    url = 'https://admisiones.ufg.edu.sv/reingresoapis/api/v1/'
    // url = 'http://127.0.0.1:4003/api/v1/'

    carnetRef = React.createRef();
    telefonoRef = React.createRef();
    nombreCompletoRef = React.createRef();
    apellidoCompletoRef = React.createRef();
    fechaNacimientoRef = React.createRef();
    duiRef = React.createRef();
    emailRef = React.createRef();
    tokenRef = React.createRef();
    switchCarnetRef = React.createRef();
    sedeSSRef = React.createRef();
    sedeCRORef = React.createRef();

    constructor(props) {
        super(props)
        this.state = { nombres: null, apellidos: null }
    }

    state = {
        requestToken: {},
        requestReingreso: {},
        subirLblNombres: false,
        subirLblApellidos: false,
        isLoading: false,
        isConnected: false,
    }

    componentDidMount() {
        $("#dui").mask("00000000-0")
        $("#telefono").mask("0000-0000")
        $("#fechaNacimiento").mask("00-00-0000")
        // Realizar la petición cada segundo y corroborar que esta funcionando la API
        //this.interval = setInterval(this.checkConnection, 1000)
        this.checkConnection()
    }

    requestToken = () => {
        var data = {
            Token: this.tokenRef.current.value.toUpperCase()
        }

        this.setState({
            requestToken: data
        })
    }

    // verifica la conexion con la API
    checkConnection = () => {
        const url = 'https://admisiones.ufg.edu.sv/reingresoapis/api/v1'
        axios.get(url).then((response) => {
            if (response.data.status == "Ok") {
                this.setState({ isConnected: true })
            } else {
                this.setState({ isConnected: false })
            }
        })
    }

    sendToken = (e) => {
        e.preventDefault()

        axios({
            url: this.url + 'consultarToken',
            method: 'post',
            data: JSON.stringify(this.state.requestToken),
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(response => {
            let flag = response.data.Code
            let token = response.data.Token
            let nombre = response.data.Nombres
            let message = response.data.Message

            if (flag === 200) {
                let name = response.data.DatosPersonales.Nombres + ' ' + response.data.DatosPersonales.Apellidos
                Swal.fire({
                    title: '<strong style="color:#EDEEEF; letter-spacing: 1px;">TOKEN: ' + token + '</strong>',
                    icon: 'success',
                    html: '<p style="color:#EDEEEF; letter-spacing: 1px;"><font size="3"><b>' + name + '</b>, ' + message + '</font></p> ',
                    background: '#1E4775',
                    showConfirmButton: false,
                    showCloseButton: true
                }).then(function () {
                    window.location.reload(true)
                })
            } else if (flag === 202) {

                let detalleInformativo = ""
                let init = "<ul>"
                let fina = "</ul>"

                if (response.data.DetalleInformativo.ActualizarDocumentos !== undefined) {
                    let actualizarDocumentos = response.data.DetalleInformativo.ActualizarDocumentos
                    init += '<li align="justify" style="color:#EDEEEF"><font size="3"> Debes Actualizar los siguientes documentos: ' + actualizarDocumentos + '</li>'
                }

                if (response.data.DetalleInformativo.FirmarModeloActa !== undefined) {
                    let firmarModeloActa = response.data.DetalleInformativo.FirmarModeloActa
                    init += '<br/><li align="justify" style="color:#EDEEEF"><font size="3">' + firmarModeloActa + '</li>'
                }

                if (response.data.DetalleInformativo.CuotasPendientes !== undefined) {
                    var payMessage = ""
                    response.data.DetalleInformativo.CuotasPendientes.forEach(function (cp) {
                        payMessage += '<li><b>Arancel: </b>' + cp.Arancel + ', <b>Monto:</b> $ ' + cp.Monto + '</li>'
                    })
                    init += '<br/><li align="left" style="color:#EDEEEF">Cuotas pendientes<ul align="left" style="color:#EDEEEF">' + payMessage + '</ul></li>'
                }
                detalleInformativo = init + fina

                Swal.fire({
                    title: '<strong style="color:#EDEEEF; letter-spacing: 1px;"> LO SENTIMOS </strong>',
                    icon: 'warning',
                    html: '<p align="justify" style="color:#EDEEEF; letter-spacing: 1px;"><font size="3"><b>' + nombre + '</b>, ' + message + '</font></p>' + detalleInformativo,
                    background: '#1E4775',
                    showConfirmButton: false,
                    showCloseButton: true
                }).then(function () {
                    window.location.reload(true)
                })
            } else {
                Swal.fire({
                    title: '<strong style="color:#EDEEEF; letter-spacing: 1px;"> LO SENTIMOS </strong>',
                    icon: 'warning',
                    html: '<p style="color:#EDEEEF; letter-spacing: 1px;"><font size="3">' + message + '</font></p> ',
                    background: '#1E4775',
                    showConfirmButton: false,
                    showCloseButton: true
                }).then(function () {
                    window.location.reload(true)
                })
            }
            return response.data
        }).catch(err => {
            let flag = 0

            if (err.response !== undefined) {
                flag = err.response.data.Code
            }
            if (flag === 404 || flag === 500) {
                let message = err.response.data.Message

                Swal.fire({
                    title: '<strong style="color:#EDEEEF; letter-spacing: 1px;"> LO SENTIMOS </strong>',
                    icon: 'error',
                    html: '<p style="color:#EDEEEF; letter-spacing: 1px;"><font size="3">' + message + '</font></p> ',
                    background: '#1E4775',
                    showConfirmButton: false,
                    showCloseButton: true
                }).then(function () {
                    window.location.reload(true)
                })
            } else {
                Swal.fire({
                    title: '<strong style="color:#EDEEEF; letter-spacing: 1px;"> ERROR </strong>',
                    icon: 'error',
                    html: '<p style="color:#EDEEEF; letter-spacing: 1px;"><font size="3">Al parecer existe un problema en el recurso, por favor intenta más tarde o puedes comunicarte al 2209-2834 para reportar el incidente..</font></p> ',
                    background: '#1E4775',
                    showConfirmButton: false,
                    showCloseButton: true
                }).then(function () {
                    window.location.reload(true)
                })
            }
            return err
        })
    }

    requestReingreso = () => {
        if (this.sedeSSRef.current.checked) {
            idSede = this.sedeSSRef.current.value
        } else {
            idSede = this.sedeCRORef.current.value
        }
        var data = {
            Token: '',
            Carnet: this.carnetRef.current.value.toUpperCase(),
            Telefono: this.telefonoRef.current.value,
            Nombres: this.nombreCompletoRef.current.value.toUpperCase(),
            Apellidos: this.apellidoCompletoRef.current.value.toUpperCase(),
            FechaNacimiento: this.fechaNacimientoRef.current.value,
            Dui: this.duiRef.current.value,
            Email: this.emailRef.current.value,
            IdSede: idSede
        }
        this.setState({
            requestReingreso: data
        })
    }

    sendReingreso = (e) => {
        e.preventDefault()
        this.checkConnection()
        var first = Math.random().toString(36).substr(2)
        var token = first.substr(0, 8).toUpperCase()
        var data = this.state.requestReingreso
        data.Token = token
        this.setState({
            requestReingreso: data
        })

        this.setState({ isLoading: true }, () => {
            axios({
                url: this.url + 'validarPersonaReingreso',
                method: 'post',
                data: JSON.stringify(this.state.requestReingreso),
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(response => {
                this.setState({
                    isLoading: false
                })
                let flag = response.data.Code

                if (flag !== undefined) {

                    let token = response.data.Token
                    let message = response.data.Message

                    if (flag === 200) {
                        let name = response.data.DatosPersonales.Nombres + ' ' + response.data.DatosPersonales.Apellidos
                        Swal.fire({
                            title: '<strong style="color:#EDEEEF; letter-spacing: 1px;">TOKEN: ' + token + '</strong>',
                            icon: 'success',
                            html: '<p style="color:#EDEEEF; letter-spacing: 1px;"><font size="3"><b>' + name + '</b>, ' + message + '</font></p> ',
                            background: '#1E4775',
                            showConfirmButton: false,
                            showCloseButton: true
                        }).then(function () {
                            window.location.reload(true)
                        })
                    } else if (flag === 201) {

                        let name = response.data.DatosPersonales.Nombres + ' ' + response.data.DatosPersonales.Apellidos
                        let detalleInformativo = ""
                        let init = "<ul>"
                        let fina = "</ul>"

                        if (response.data.DetalleInformativo.ActualizarDocumentos !== undefined) {
                            let actualizarDocumentos = response.data.DetalleInformativo.ActualizarDocumentos
                            init += '<li align="justify" style="color:#EDEEEF; padding: 5px; letter-spacing: 1px;"><font size="3"> Debes Actualizar los siguientes documentos: ' + actualizarDocumentos + '</li>'
                        }

                        if (response.data.DetalleInformativo.FirmarModeloActa !== undefined) {
                            let firmarModeloActa = response.data.DetalleInformativo.FirmarModeloActa
                            init += '<br/><li align="justify" style="color:#EDEEEF"><font size="3">' + firmarModeloActa + '</li>'
                        }

                        if (response.data.DetalleInformativo.CuotasPendientes !== undefined) {
                            var payMessage = ""
                            response.data.DetalleInformativo.CuotasPendientes.forEach(function (cp) {
                                payMessage += '<li style="padding: 5px; letter-spacing: 1px;"><b>Arancel: </b>' + cp.Arancel + '. </br><b>Monto:</b> ' + cp.Monto + '</li>'
                            })
                            init += '<br/><li align="left" style="color:#EDEEEF">Cuotas pendientes<ul align="left" style="color:#EDEEEF">' + payMessage + '</ul></li>'
                        }
                        detalleInformativo = init + fina

                        Swal.fire({
                            title: '<strong style="color:#EDEEEF; letter-spacing: 1px;">TOKEN: ' + token + '</strong>',
                            icon: 'warning',
                            html: '<p align="justify" style="color:#EDEEEF; letter-spacing: 1px;"><font size="3"><b>' + name + '</b>, ' + message + '</font></p>' + detalleInformativo,
                            background: '#1E4775',
                            showConfirmButton: false,
                            showCloseButton: true
                        }).then(function () {
                            window.location.reload(true)
                        })
                    } else {
                        Swal.fire({
                            title: '<strong style="color:#EDEEEF; letter-spacing: 1px;">LO SENTIMOS </strong>',
                            icon: 'warning',
                            html: '<p style="color:#EDEEEF; letter-spacing: 1px;"><font size="3">' + message + '</font></p> ',
                            background: '#1E4775',
                            showConfirmButton: false,
                            showCloseButton: true
                        }).then(function () {
                            window.location.reload(true)
                        })
                    }
                } else {
                    Swal.fire({
                        title: '<strong style="color:#EDEEEF; letter-spacing: 1px;"> ERROR </strong>',
                        icon: 'error',
                        html: '<p style="color:#EDEEEF; letter-spacing: 1px;"><font size="3">Al parecer existe un problema, por favor intenta mas tarde...</font></p> ',
                        background: '#1E4775',
                        showConfirmButton: false,
                        showCloseButton: true
                    }).then(function () {
                        window.location.reload(true)
                    })
                }

                return response.data
            }).catch(err => {
                if (err.response !== undefined) {
                    let mess = err.response.data.Message

                    if (err.response.data.Code === 404) {
                        Swal.fire({
                            title: '<strong style="color:#EDEEEF; letter-spacing: 1px;">LO SENTIMOS </strong>',
                            icon: 'warning',
                            html: '<p style="color:#EDEEEF; letter-spacing: 1px;"><font size="3">' + mess + '</font></p> ',
                            background: '#1E4775',
                            showConfirmButton: false,
                            showCloseButton: true
                        }).then(function () {
                            window.location.reload(true)
                        })
                    } else {
                        Swal.fire({
                            title: '<strong style="color:#EDEEEF; letter-spacing: 1px;"> LO SENTIMOS </strong>',
                            icon: 'error',
                            html: '<p style="color:#EDEEEF; letter-spacing: 1px;"><font size="3">' + mess + '</font></p> ',
                            background: '#1E4775',
                            showConfirmButton: false,
                            showCloseButton: true
                        }).then(function () {
                            window.location.reload(true)
                        })
                    }
                } else {
                    Swal.fire({
                        title: '<strong style="color:#EDEEEF; letter-spacing: 1px;"> ERROR </strong>',
                        icon: 'error',
                        html: '<p style="color:#EDEEEF; letter-spacing: 1px;"><font size="3">Al parecer existe un problema intenta mas tarde...</font></p> ',
                        background: '#1E4775',
                        showConfirmButton: false,
                        showCloseButton: true
                    }).then(function () {
                        window.location.reload(true)
                    })
                }
                return err
            })
        })
    }

    enabledCarnet = () => {
        if (this.switchCarnetRef.current.checked) {
            habilitar = false
            this.nombreCompletoRef.current.value = null
            this.apellidoCompletoRef.current.value = null
            this.setState({
                nombres: null,
                apellidos: null,
                subirLblNombres: false,
                subirLblApellidos: false
            })
        } else {
            this.carnetRef.current.value = null
            habilitar = true
            this.nombreCompletoRef.current.value = null
            this.apellidoCompletoRef.current.value = null
            this.setState({
                nombres: null,
                apellidos: null,
                subirLblNombres: false,
                subirLblApellidos: false
            })
        }
    }

    completeFields = () => {
        this.checkConnection()
        let carnet = this.carnetRef.current.value.toUpperCase()
        if (carnet.length === 8) {
            var requestCompleteFields = {
                Carnet: carnet,
            }
            axios({
                url: this.url + 'completeFieldReingreso',
                method: 'post',
                data: JSON.stringify(requestCompleteFields),
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then((res) => {
                let flag = res.data.Code
                let message = res.data.Message

                if (flag === 200) {
                    this.setState({
                        subirLblNombres: true,
                        subirLblApellidos: true,
                        nombres: res.data.Nombres,
                        apellidos: res.data.Apellidos
                    })
                } else if (flag === 202) {
                    this.carnetRef.current.value = null
                    this.nombreCompletoRef.current.value = null
                    this.apellidoCompletoRef.current.value = null

                    Swal.fire({
                        title: '<strong style="color:#EDEEEF; letter-spacing: 1px;"> FELICIDADES </strong>',
                        icon: 'success',
                        html: '<p style="color:#EDEEEF; letter-spacing: 1px;"><font size="3">' + message + '</font></p> ',
                        background: '#1E4775',
                        showConfirmButton: false,
                        showCloseButton: true
                    }).then(function () {
                        window.location.reload(true)
                    })
                } else {
                    this.carnetRef.current.value = null
                    this.nombreCompletoRef.current.value = null
                    this.apellidoCompletoRef.current.value = null

                    Swal.fire({
                        title: '<strong style="color:#EDEEEF; letter-spacing: 1px;"> LO SENTIMOS </strong>',
                        icon: 'warning',
                        html: '<p style="color:#EDEEEF; letter-spacing: 1px;"><font size="3">' + message + '</font></p> ',
                        background: '#1E4775',
                        showConfirmButton: false,
                        showCloseButton: true
                    }).then(function () {
                        window.location.reload(true)
                    })
                }

            }).catch((err) => {
                this.carnetRef.current.value = null
                this.nombreCompletoRef.current.value = null
                this.apellidoCompletoRef.current.value = null

                this.setState({
                    subirLblNombres: false,
                    subirLblApellidos: false,
                    nombres: null,
                    apellidos: null
                })

                if (err.response !== undefined) {
                    if (err.response.data.Code === 500 || 404) {
                        Swal.fire({
                            title: '<strong style="color:#EDEEEF; letter-spacing: 1px;"> LO SENTIMOS </strong>',
                            icon: 'warning',
                            html: '<p style="color:#EDEEEF; letter-spacing: 1px;"><font size="3">' + err.response.data.Message + '</font></p> ',
                            background: '#1E4775',
                            showConfirmButton: false,
                            showCloseButton: true
                        })
                    } else {
                        Swal.fire({
                            title: '<strong style="color:#EDEEEF; letter-spacing: 1px;"> ERROR </strong>',
                            icon: 'warning',
                            html: '<p style="color:#EDEEEF; letter-spacing: 1px;"><font size="3">El carnet ingresado no existe en nuestros registros de aspirantes a reingresos.</font></p> ',
                            background: '#1E4775',
                            showConfirmButton: false,
                            showCloseButton: true
                        })
                    }
                } else {
                    Swal.fire({
                        title: '<strong style="color:#EDEEEF; letter-spacing: 1px;"> ERROR </strong>',
                        icon: 'error',
                        html: '<p style="color:#EDEEEF; letter-spacing: 1px;"><font size="3">Al parecer existe un problema intenta mas tarde...</font></p> ',
                        background: '#1E4775',
                        showConfirmButton: false,
                        showCloseButton: true
                    })
                }
            })
        } else {
            this.carnetRef.current.value = null
            this.nombreCompletoRef.current.value = null
            this.apellidoCompletoRef.current.value = null

            this.setState({
                subirLblNombres: false,
                subirLblApellidos: false,
                nombres: null,
                apellidos: null
            })

            Swal.fire({
                title: '<strong style="color:#EDEEEF; letter-spacing: 1px;"> ERROR </strong>',
                icon: 'error',
                html: '<p style="color:#EDEEEF; letter-spacing: 1px;"><font size="3">Al parecer el carnet ingresado no es valido...</font></p> ',
                background: '#1E4775',
                showConfirmButton: false,
                showCloseButton: true
            })
        }
    }

    focusNombres = () => {
        this.setState({
            subirLblNombres: true,
        })
    }

    blurNombres = () => {
        if (this.nombreCompletoRef.current.value === "") {
            this.setState({
                subirLblNombres: false,
            })
        }
    }

    focusApellidos = () => {
        this.setState({
            subirLblApellidos: true,
        })
    }

    blurApellidos = () => {
        if (this.apellidoCompletoRef.current.value === "") {
            this.setState({
                subirLblApellidos: false,
            })
        }
    }

    obtenerFecha = (date) => {
        this.setState({
            fecha: date
        })
    }

    render() {
        const { isConnected } = this.state
        return (
            <div>
                <div className="contenedor" id="contenedor">
                    <div className="form-contenedor sign-up-contenedor">
                        <form action="#" className="formReingreso" onChange={this.requestReingreso} onSubmit={this.sendReingreso}>
                            <MDBContainer>
                                <MDBRow >
                                    <MDBCol size="12" sm="12" md="12" lg="12" xl="12">
                                        <h4 className="tituloH2">FORMULARIO DE REINGRESO</h4>
                                    </MDBCol>
                                </MDBRow>

                                <MDBRow className="marginTopRow2">
                                    <MDBCol size="12" sm="12" md="12" lg="12" xl="12">
                                        <FormControlLabel
                                            label="¿Recuerda su carné?"
                                            control={<Switch value="checkedC" />}
                                            fullWidth={true}
                                            onChange={this.enabledCarnet}
                                            inputRef={this.switchCarnetRef}
                                        />
                                    </MDBCol>
                                </MDBRow>

                                <MDBRow>
                                    <MDBCol size="6" sm="6" md="6" lg="6" xl="6">
                                        <TextField
                                            id="carnet"
                                            name="carnet"
                                            label="Carné"
                                            fullWidth={true}
                                            autoComplete='off'
                                            inputRef={this.carnetRef}
                                            disabled={habilitar}
                                            onBlur={this.completeFields}
                                            inputProps={{
                                                maxLength: 8
                                            }}
                                        />
                                    </MDBCol>

                                    <MDBCol size="6" sm="6" md="6" lg="6" xl="6">
                                        <TextField
                                            id="telefono"
                                            name="telefono"
                                            label="Teléfono"
                                            fullWidth={true}
                                            autoComplete='off'
                                            inputRef={this.telefonoRef}
                                        />
                                    </MDBCol>
                                </MDBRow>

                                <MDBRow>
                                    <MDBCol size="6" sm="6" md="6" lg="6" xl="6">
                                        <TextField
                                            label="Nombres"
                                            id="nombres"
                                            name="nombres"
                                            fullWidth={true}
                                            autoComplete='off'
                                            required
                                            value={this.state.nombres}
                                            InputLabelProps={{ shrink: this.state.subirLblNombres }}
                                            inputRef={this.nombreCompletoRef}
                                            onFocus={this.focusNombres}
                                            onBlur={this.blurNombres}
                                            inputProps={{
                                                maxLength: 30
                                            }}
                                        />
                                    </MDBCol>

                                    <MDBCol size="6" sm="6" md="6" lg="6" xl="6">
                                        <TextField
                                            label="Apellidos"
                                            id="apellidos"
                                            name="apellidos"
                                            fullWidth={true}
                                            autoComplete='off'
                                            required
                                            InputLabelProps={{ shrink: this.state.subirLblApellidos }}
                                            value={this.state.apellidos}
                                            inputRef={this.apellidoCompletoRef}
                                            onFocus={this.focusApellidos}
                                            onBlur={this.blurApellidos}
                                            inputProps={{
                                                maxLength: 30
                                            }}
                                        />
                                    </MDBCol>
                                </MDBRow>

                                <MDBRow>
                                    <MDBCol size="6" sm="6" md="6" lg="6" xl="6">
                                        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                                            <DatePicker
                                                id="fechaNacimiento"
                                                name="fechaNacimiento"
                                                label="Nacimiento"
                                                disableFuture
                                                openTo="year"
                                                views={["year", "month", "date"]}
                                                fullWidth={true}
                                                autoComplete='off'
                                                required
                                                format="dd-MM-yyyy"
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                onChange={this.obtenerFecha}
                                                inputRef={this.fechaNacimientoRef}
                                                value={this.state.fecha ? this.state.fecha : null}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </MDBCol>

                                    <MDBCol size="6" sm="6" md="6" lg="6" xl="6">
                                        <TextField
                                            label="DUI"
                                            id="dui"
                                            name="dui"
                                            fullWidth={true}
                                            autoComplete='off'
                                            inputRef={this.duiRef}
                                        />
                                    </MDBCol>
                                </MDBRow>

                                <MDBRow>
                                    <MDBCol size="12" sm="12" md="12" lg="12" xl="12">
                                        <TextField
                                            label="Email"
                                            id="email"
                                            name="email"
                                            fullWidth={true}
                                            autoComplete='off'
                                            required
                                            inputRef={this.emailRef}
                                            inputProps={{
                                                maxLength: 150
                                            }}
                                        />
                                    </MDBCol>
                                </MDBRow>

                                <MDBRow className="marginTopRow2">
                                    <MDBCol size="12" sm="12" md="12" lg="12" xl="12">
                                        <FormLabel component="legend" style={{ textAlign: "left" }}><center>Sede de reingreso</center></FormLabel>
                                        <RadioGroup
                                            defaultValue="1"
                                            id="sede"
                                            name="sede"
                                            fullWidth={true}
                                        >
                                            <div className="row">
                                                <div className="col-12  text-center">
                                                    <FormControlLabel
                                                        value="1"
                                                        inputRef={this.sedeSSRef}
                                                        control={<Radio color="primary" />}
                                                        label="San Salvador"
                                                    />
                                                </div>
                                            </div>
                                        </RadioGroup>
                                    </MDBCol>
                                </MDBRow>

                                <MDBRow className="marginTopRow2">
                                    <MDBCol size="12" sm="12" md="12" lg="12" xl="12">
                                        {/* <button className="boton lightBlue marginTop3" type="submit">ENVIAR</button> */}
                                        {this.state.isLoading ? (
                                            <Button
                                                color="primary"
                                                variant="contained"
                                                disabled={this.state.isLoading}
                                                type="submit"
                                                size="large"
                                                startIcon={<Spinner animation="border" />}
                                            >
                                                CARGANDO
                                            </Button>
                                        ) : (
                                            <Button
                                                color="primary"
                                                variant="contained"
                                                type="submit"
                                                size="large"
                                                startIcon={<SendIcon />}
                                            >
                                                ENVIAR
                                            </Button>
                                        )}
                                    </MDBCol>
                                </MDBRow>


                            </MDBContainer>
                        </form>
                    </div>
                    <div className="form-contenedor sign-in-contenedor">
                        <form action="#" className="formReingreso" onChange={this.requestToken} onSubmit={this.sendToken}>
                            <MDBContainer>
                                <MDBRow>
                                    <MDBCol size="12" sm="12" md="12" lg="12" xl="12">
                                        <h1 className="tituloH1">Trámite de Reingreso</h1>
                                    </MDBCol>
                                </MDBRow>

                                <MDBRow className="marginTopRow2">
                                    <MDBCol size="12" sm="12" md="12" lg="12" xl="12">
                                        <TextField
                                            label="Ingrese su número de Token"
                                            id="token"
                                            name="token"
                                            autoComplete='off'
                                            fullWidth={true}
                                            required
                                            inputRef={this.tokenRef}
                                            inputProps={{
                                                maxLength: 8
                                            }}
                                        />
                                    </MDBCol>
                                </MDBRow>

                                <MDBRow className="marginTopRow2">
                                    <MDBCol size="12" sm="12" md="12" lg="12" xl="12">
                                        <button className="boton lightBlue marginTop">INGRESAR</button>
                                    </MDBCol>
                                </MDBRow>
                            </MDBContainer>

                        </form>
                    </div>
                    <div className="overlay-contenedor">
                        <div className="overlay">
                            <div className="overlay-panel overlay-left">
                                <h1 className="tituloH1">¿Ya tienes Token?</h1>
                                <p className="parrafoFormulario">Si ya posees tu número de Token, puedes continuar el proceso aquí</p>
                                <button className="boton orange" id="signIn">INGRESAR</button>
                                {/* <div id="connection-status"></div> */}
                                <div
                                    style={{
                                        backgroundColor: isConnected ? 'green' : 'red',
                                    }}
                                    className="connection-status"
                                />
                            </div>
                            <div className="overlay-panel overlay-right">
                                <h1 className="tituloH1">¿No tienes Token?</h1>
                                <p className="parrafoFormulario marginTop">Si no posees tu número de Token, llena el formulario de reingreso</p>
                                <button className="boton orange" id="signUp">REINGRESO</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        )
    }
}
export default FormReingreso